// const spacing = factor => [0, 5, 10, 15, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130][factor];
const spacing = factor => factor * 10

export default spacing
